/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
// FaturaPage.js
import { useEffect, useState, useContext } from "react";
import styled from "styled-components";
import { Sidebar } from "../components/Sidebar";
import { AuthContext } from "../context/AuthContext";
import { FaThLarge, FaList } from "react-icons/fa";
import { API_BASE_URL } from "../config";

export const FaturaPage = () => {
  const { logout, token } = useContext(AuthContext);
  const [boletos, setBoletos] = useState([]);
  const [cliente, setCliente] = useState(null);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState("grid");

  useEffect(() => {
    document.title = "Minhas Faturas";
    fetchBoletos();
  }, []);

  const fetchBoletos = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/list_documents`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      console.log(data);
      if (data.sucesso) {
        setCliente(data.cliente || null);
        setBoletos(data.dados || []);
      } else {
        console.error(data.erro);
      }
    } catch (error) {
      console.error("Erro ao buscar faturas:", error);
    } finally {
      setLoading(false);
    }
  };

  const toggleView = () => {
    setViewMode((prev) => (prev === "grid" ? "list" : "grid"));
  };

  return (
    <Wrapper>
      <Sidebar />
      <Main>
        <Content>
          <ViewToggle>
            <IconButton
              onClick={() => setViewMode("grid")}
              active={viewMode === "grid"}
            >
              <FaThLarge />
            </IconButton>
            <IconButton
              onClick={() => setViewMode("list")}
              active={viewMode === "list"}
            >
              <FaList />
            </IconButton>
          </ViewToggle>

          {loading ? (
            <p>Carregando faturas...</p>
          ) : Array.isArray(boletos) && boletos.length === 0 ? (
            <EmptyMessage>Nenhuma fatura encontrada.</EmptyMessage>
          ) : (
            <FaturaList viewMode={viewMode}>
              {boletos.map((boleto) => (
                <FaturaCard
                  key={boleto.id}
                  status={boleto.status}
                  viewMode={viewMode}
                >
                  <p>
                    <strong>Nome:</strong> {cliente?.name ?? "—"}
                  </p>
                  <p>
                    <strong>ID:</strong> {boleto.id}
                  </p>
                  <p>
                    <strong>Valor:</strong> R${" "}
                    {boleto.value.toFixed(2).replace(".", ",")}
                  </p>
                  <p>
                    <strong>Vencimento:</strong>{" "}
                    {new Date(boleto.dueDate).toLocaleDateString("pt-BR")}
                  </p>
                  <p>
                    <strong>Status:</strong>{" "}
                    {boleto.status === "PENDING"
                      ? "🟡 Pendente"
                      : boleto.status === "RECEIVED"
                      ? "✅ Pago"
                      : boleto.status === "OVERDUE"
                      ? "🔴 Atrasado"
                      : "❌ " + boleto.status}
                  </p>
                  <a href={boleto.invoiceUrl} target="_blank" rel="noreferrer">
                    Ver Boleto
                  </a>
                </FaturaCard>
              ))}
            </FaturaList>
          )}
        </Content>
      </Main>
    </Wrapper>
  );
};

// Styled Components
const Wrapper = styled.div`
  min-height: 100dvh;
  background: #0f0f0f;
  color: #fff;
  padding-top: 60px; /* altura do header */
  padding-left: 240px; /* espaço da sidebar no desktop */
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;

  @media (max-width: 760px) {
    padding-left: 0; /* sem espaço fixo no mobile */
  }
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;

  /* CRUCIAL em layouts flex: permite encolher e não forçar largura */
  min-width: 0;
`;

const Content = styled.div`
  padding: 2rem;
  display: grid;
  gap: 1.5rem;
`;

const EmptyMessage = styled.p`
  text-align: center;
  color: #bbb;
  font-style: italic;
  margin-top: 2rem;
`;

const ViewToggle = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

const IconButton = styled.button`
  background: ${({ active }) => (active ? "#3498db" : "#222")};
  color: #fff;
  border: none;
  padding: 0.6rem 0.8rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.3s;

  &:hover {
    background: #2980b9;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

const FaturaList = styled.div`
  display: ${({ viewMode }) => (viewMode === "grid" ? "grid" : "block")};
  gap: 1rem;
  grid-template-columns: ${({ viewMode }) =>
    viewMode === "grid" ? "repeat(auto-fit, minmax(280px, 1fr))" : "none"};
`;

const FaturaCard = styled.div`
  background: #1f1f1f;
  border-left: 5px solid
    ${({ status }) =>
      status === "RECEIVED"
        ? "#2ecc71"
        : status === "PENDING"
        ? "#f1c40f"
        : "#e74c3c"};
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: ${({ viewMode }) => (viewMode === "list" ? "20px" : "0")};

  a {
    color: #4faaff;
    text-decoration: underline;
  }
`;
